export default __webpack_public_path__ + "static/media/success-blue-check-mark.278c1320.svg";